import type { Currency } from '../types/api.types';
import { CURRENCY_SYMBOLS } from '../types/api.types';

export function formatCurrencyInput(digits: string, currency: Currency): string {
    if (!digits) return '';
    const [intPart, decPart] = digits.split('.');
    const locale = currency === 'INR' ? 'en-IN' : 'en-US';
    const formattedInt = intPart !== '' ? new Intl.NumberFormat(locale).format(Number(intPart)) : '';
    return decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
}

// Strips commas and keeps only digits + one optional decimal point
export function extractNumericInput(value: string): string {
    const stripped = value.replace(/,/g, '');
    const match = stripped.match(/^\d*\.?\d*/);
    return match ? match[0] : '';
}

// Formats a numeric amount for display with locale-correct comma grouping and currency symbol.
// INR uses en-IN grouping (10,00,000); USD and CAD use en-US (1,000,000).
export function formatAmount(amount: number, currency: Currency): string {
    const locale = currency === 'INR' ? 'en-IN' : 'en-US';
    const symbol = CURRENCY_SYMBOLS[currency];
    return `${symbol}${new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(amount)}`;
}
